<template>
 <footer id="dfoot">
   <div class="foot">
     <div class="main">
       <div class="lf info">
         <h2>
            <a :href="url">
             <img src="../assets/image/foot-logo.png" alt="企业福利助手"/>
            </a>
         </h2>
         <div>
           <a :href="url+'home'">首页</a> |
           <a :href="url+'programme'">福利方案</a> |
           <a :href="url+'about'">关于我们</a>
         </div>
         <P><a rel="nofollow" href="https://www.daishujiankang.com/" target="_blank">友情链接：袋鼠健康</a></P>
       </div>
       <div class="rt contact">
         <ul class="lf">
           <li>
             <a>
              <P>咨询热线</P>
              <P>4001-0755-70 转6</P>
             </a>
           </li>
           <li>
             <a rel="nofollow" href="mailto:dary@suncomit.com">
              <P>咨询邮箱</P>
              <P>service@daishujiankang.com</P>
             </a>
           </li>
           <li>
             <a>
              <P>工作时间</P>
              <P>8:30-18:30</P>
             </a>
           </li>
         </ul>
         <div class="rt">
           <img src="../assets/image/foot-wechat.png"/>
           <p>关注福利公众号</p>
         </div>
       </div>
     </div>
     <div class="social">
       <ul>
         <li>&copy;2015~2019 讯康信息技术(深圳)有限公司</li> |
         <li><a rel="nofollow" href="https://www.daishujiankang.com/article/permission" target="_blank">粤B2-20170372</a></li> |
         <li><a rel="nofollow" href="https://www.daishujiankang.com/article/certification" target="_blank">ISO27001国际信息安全认证</a></li> |
         <!-- <li><a rel="nofollow" href="http://szcert.ebs.org.cn/32803a68-3293-4b27-8512-43b9bdce4b88" target="_blank">工商网监认证</a></li> | -->
         <li><a rel="nofollow" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502001091" target="_blank">粤公网安备</a></li> |
         <li><a rel="nofollow" href="http://beian.miit.gov.cn" target="_blank">粤ICP备16043375号</a></li>
       </ul>
     </div>
   </div>
 </footer>
</template>
<script>
export default {
  name: 'DFoot',
  data() {
    return {
      url: this.baseUrl
    }
  }
}
</script>
<style scoped lang="less">
  #dfoot {
    width: 100%;
    height: 292px;
    background: #4C4C4C;
    .foot {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      .main {
        overflow: hidden;
        .info {
          &>h2 {
            margin-top: 40px;
            a {
              img {
                height: 45px;
                width: 165px;
              }
            }
          }
          &>div, &>div>a, &>p>a {
            margin-top: 35px;
            font-size:14px;
            font-family: @PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:20px;
          }
          &>div {
            &>a {
              padding: 0 20px;
            }
            &>a:nth-child(1) {
              padding: 0px 20px 0px 0px;
            }
          }
          &>p {
            margin-top: 35px;
            a {
              cursor: pointer;
            }
          }
        }
        .contact {
          border-left: 2px solid #979797;
          padding-left: 26px;
          margin-top: 30px;
          overflow: hidden;
          &>ul {
            li {
              color:rgba(151,151,151,1);
              margin-top: 27px;
              a {
                display: inline-block;
                padding-left: 40px;
                color:rgba(151,151,151,1);
                cursor: pointer;
                &>p:nth-child(1) {
                  font-size:12px;
                  font-family: @PingFangSC-Regular;
                  font-weight:400;
                  line-height:17px;
                }
                &>p:nth-child(2) {
                  font-size:14px;
                  font-family: @PingFangSC-Semibold;
                  font-weight:600;
                  line-height:20px;
                }
              }
            }
            li:nth-child(1) {
              color:rgba(255,255,255,1);
              a {
                color:rgba(255,255,255,1);
              }
              margin-top: 0px;
              background: url('@{image}foot-tel.png') no-repeat 1px center / 24px 24px;
            }
            li:nth-child(2) {
              background: url('@{image}foot-email.png') no-repeat left center / 26px 26px;
            }
            li:nth-child(3) {
              background: url('@{image}foot-time.png') no-repeat left center / 26px 26px;
            }
          }
          &>div {
            margin-left: 55px;
            margin-right: 37px;
            img {
              height: 110px;
              width: 110px;
              margin-bottom: 12px;
            }
            p {
              font-size:12px;
              font-family: @PingFangSC-Medium;
              font-weight:500;
              color:rgba(140,140,140,1);
              line-height:17px;
              text-align: center;
            }
          }
        }
      }
      .social {
        margin-top: 46px;
        &>ul, &>ul>li, &>ul>li>a {
          font-size:14px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:20px;
        }
        &>ul {
          li {
            display: inline-block;
            padding: 0px 20px;
            a {
              cursor: pointer;
            }
          }
          li:nth-child(1) {
            padding: 0px 20px 0px 0px;
          }
          // li:nth-child(4) {
          //   background: url('@{image}foot-social1.png') no-repeat 20px center / 16px 16px;
          //   padding-left: 48px;
          // }
          li:nth-child(4) {
            background: url('@{image}foot-social2.png') no-repeat 20px center / 16px 16px;
            padding-left: 49px;
          }
        }
      }
    }
  }
</style>
